import React, { CSSProperties } from 'react';
import Popup, { Props } from 'reactjs-popup';

import { getContentStyle, getArrowStyle, overlayStyle, TooltipAnimation } from './styles';

const tuple = <T extends string[]>(...args: T) => args;

export const tooltipHintView = tuple(
  'success',
  'warning',
  'error',
  'danger',
  'info',
  'alert',
  'buy',
  'sell'
);

type Position =
  | 'top left'
  | 'top center'
  | 'top right'
  | 'right top'
  | 'right center'
  | 'right bottom'
  | 'bottom left'
  | 'bottom center'
  | 'bottom right'
  | 'left top'
  | 'left center'
  | 'left bottom'
  | 'center center';

export interface TooltipHintProps {
  position?: Position | Position[];
  hasArrow?: boolean;
  padding?: string;
  view?: typeof tooltipHintView[number];
  arrow?: boolean;
}

export const TooltipHint: React.FC<Props & TooltipHintProps> = props => {
  const { position = 'top center', padding, view = 'success' } = props;

  const paddingDefault = '1rem 2rem';

  const contentStyleCombined = getContentStyle(view);

  const arrowStyle = getArrowStyle(view);

  const combinedStyles = {
    ...contentStyleCombined,
    ...TooltipAnimation,
    padding: padding || paddingDefault
  };

  return (
    <Popup
      arrow={true}
      position={position}
      contentStyle={combinedStyles as CSSProperties}
      overlayStyle={overlayStyle}
      arrowStyle={arrowStyle}
      {...props}
    >
      {props.children}
    </Popup>
  );
};
